<template>
    <div class="home">
        <header-view
            :titulo="titulo" 
            :categories="categories">
        </header-view>

        <!-- Empresas -->
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="title-section">
                        <h2>Em destaque</h2>
                    </div>
                </div>
            </div>
        </div>

        <pulse-loader :loading="loading" class="text-center"></pulse-loader>

        <div class="commerce-section">
            <div class="container">

                <div class="row" v-if="status">

                    <div class="col-md-3 col-sm-4 item" v-for="(data,index) in clients" :key="index">
                        <div class="thumbnail">
                            <!--<router-link :to="'/empresa/'+data.client_id">-->
                                <figure>
                                    <img :src="data.image" alt="" class="img-responsive">
                                </figure>
                                <div class="caption">
                                    <h3>{{(data.name !== '') ? data.name : data.trade_name}}</h3>
                                    <p>{{data.city}} <span v-if="data.city && data.state">|</span> {{data.state}}</p>
                                </div>
                            <!--</router-link>-->
                        </div>
                    </div>

                </div>

                <div class="row" v-if="clients.length == 0">
                  <div class="col-md-12 col-sm-12">
                    <p class="text-center">Nenhum resultado.</p>
                  </div>
                </div>

                <div class="nav-footer">
                    <div class="row">
                        <div class="col-md-4 col-xs-12 hide">
                            <a href="#" class="btn-more">
                                + Ver mais
                            </a>
                        </div>

                        <paginate
                          :pageCount="meta.last_page"
                          :clickHandler="getHome"
                          :prevText="'<span aria-hidden=\'true\'><i class=\'fa fa-angle-double-left\'></i></span>'"
                          :nextText="'<span aria-hidden=\'true\'><i class=\'fa fa-angle-double-right\'></i></span>'"
                          :containerClass="'pagination'">
                        </paginate>

                    </div>
                </div>


            </div>
        </div>
        <!-- / End Empresas -->

        <footer-view></footer-view>
    </div>
</template>

<script>
import HeaderView from './layout/Header'
import FooterView from './layout/Footer'
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import Paginate from 'vuejs-paginate'
import HTTP_Api from "../services/api.service";

export default {
  name: 'Home',
  props: {
  },
  components: {
    HeaderView,
    FooterView,
    PulseLoader,
    Paginate
  },
  data: function () {
    return {
      titulo: 'Portal de Publicações',
      categories: [],
      clients: Object,
      meta: [],
      loading: true,
      status: false,
      classes: {
        fixed_layout: '',
        hide_logo: ''
      }
    }
  },
  methods: {
    getHome(pagenum) {
      this.loading = true;
      HTTP_Api.getHomeData(pagenum)
        .then(response => {
          this.status = response.data.status;
          this.clients = response.data.clients;
          this.categories = response.data.categories;
          this.meta = response.data.meta;
          this.loading = false;
          //console.log('this.clients',this.clients)
        })
        .catch(e => {
          this.errors.push(e);
        });
    },
    createPaginationBinds() {
      var self = this;
      this.$refs["pageLink"].addEventListener("click", function(event) {
        event.preventDefault();
        const pagenum = event.target.getAttribute("data-ci-pagination-page");
        self.clients = [];
        self.getHome(pagenum);
      });
    },
  },
  created() {
    this.getHome();
  },
  computed: {
    user () {
      return {
        displayName: '',
        avatar: '',
        roles: ['', '']
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Home.vue